import api from './api';

export const submitFeedback = async (message) => {
  const response = await api.post('/feedback/', { message });
  return response.data;
};
